import * as GC from '@grapecity/spread-sheets';
import { spreadsheetConfig } from '@shared/spreadsheet/spreadsheet-config';

export function outputReportNumberCellType(displayValue: string | number) {
  // Helper function
  const paintValue = (ctx, value, x, y, w, h, style, context) => {
    if (!ctx) return;

    // Overwriting the paint property with the modified value
    // ------------------------------------------------------
    // Value to Paint (but not real value of the cell)
    const displayZeroAs: string | number = spreadsheetConfig.displayZeroAs;
    value = 0 == Number(displayValue) ? displayZeroAs : displayValue;
    return new GC.Spread.Sheets.CellTypes.Base().paint(ctx, value, x, y, w, h, style, context);
  };

  // Logic
  function _outputReportNumberCellType() {}
  _outputReportNumberCellType.prototype = new GC.Spread.Sheets.CellTypes.Base();
  _outputReportNumberCellType.prototype.paint = paintValue;

  return new _outputReportNumberCellType();
}
